import {useState} from 'react';
import {MeterAssignment} from '../types';

let selectedRecords: MeterAssignment[] = [];
const listeners: (() => void)[] = [];

const notifyListeners = () => {
    listeners.forEach(listener => listener());
};

export const useMeterAssignmentsSelection = () => {
    const [, forceUpdate] = useState({});

    const rerender = () => forceUpdate({});

    if (!listeners.includes(rerender)) {
        listeners.push(rerender);
    }

    const setSelectedRecords = (records: MeterAssignment[]) => {
        selectedRecords = records;
        notifyListeners();
    };

    const clearSelection = () => {
        selectedRecords = [];
        notifyListeners();
    };

    return {
        selectedRecords,
        setSelectedRecords,
        clearSelection,
        handleClearSelection: clearSelection,
        hasSelection: selectedRecords.length > 0
    };
};
